import { useTranslation } from "react-i18next";
import ItemPackageRow from "./ItemPackageRow";

function ItemPackages({
  item,
  setItem,
  setDefinePackaging,
  definePackaging,
  isAdmin,
}) {
  const { t } = useTranslation();

  return item.itemPackages.filter((p) => p.packageType === "unit").length >
    0 ? (
    <>
      {item.itemPackages
        .filter((p) => p.packageType === "unit")
        .map((unitPackage, key) => (
          <ItemPackageRow
            key={key}
            item={item}
            setItem={setItem}
            unitPackage={unitPackage}
            setDefinePackaging={setDefinePackaging}
            definePackaging={definePackaging}
            isAdmin={isAdmin}
          />
        ))}
    </>
  ) : (
    <div className="w-full text-red-800 text-center rounded border border-red-200 text-sm p-3 px-4 bg-red-50 ">
      {t("settings.items.itemPackage.notDefine")}
      <span className="font-bold ml-2">
        {t("settings.items.itemPackage.mandatoryStep")}
      </span>
    </div>
  );
}

export default ItemPackages;
